import { gql } from '@apollo/client/core';

const FETCH_ONBOARDING_STATUS = gql`
  query {
    memberOnboarding {
      complete
    }
  }
`;

const FETCH_ONBOARDING_STATUS_COMPLETE = gql`
  query {
    memberOnboarding {
      complete
      careTypeTask {
        complete
        careType
      }
    }
  }
`;

const FETCH_ONBOARDING_CARE_TYPE_TASK = gql`
  query {
    memberOnboarding {
      careTypeTask {
        complete
        careType
      }
    }
  }
`;

const FETCH_SITTER_LOCATION = gql`
  query Location {
    viewer {
      location {
        cityname
        stateabbr
        zipcode
        geoPoint {
          x
          y
        }
      }
    }
  }
`;

const FETCH_AVERAGE_SITTER_PAY_RATE = gql`
  query ($geoPointX: Decimal!, $geoPointY: Decimal!, $careType: String!, $yearsExperience: Int) {
    sitterSearch(
      searchParams: { careType: $careType, geoPoint: { x: $geoPointX, y: $geoPointY }, yearsExperience: $yearsExperience }
    ) {
      averagePayRate
    }
  }
`;

const FETCH_JOB_COUNT = gql`
  query JobSearch($searchParams: JobSearchInput!) {
    jobSearch(searchParams: $searchParams) {
      totalCount
    }
  }
`;

const FETCH_SITTER_COUNT = gql`
  query SitterSearchCount($geoPointX: Decimal!, $geoPointY: Decimal!) {
    sitterSearch(first: 1, searchParams: { geoPoint: { x: $geoPointX, y: $geoPointY } }) {
      totalCount
    }
  }
`;

export default {
  FETCH_ONBOARDING_STATUS,
  FETCH_ONBOARDING_STATUS_COMPLETE,
  FETCH_ONBOARDING_CARE_TYPE_TASK,
  FETCH_SITTER_LOCATION,
  FETCH_AVERAGE_SITTER_PAY_RATE,
  FETCH_JOB_COUNT,
  FETCH_SITTER_COUNT,
};
